/**
 * 框架underscore中函数节流和函数防抖的源码
 */
const _ = {};
_.now = Date.now || function() {
    return new Date().getTime();
};
_.throttle = function (func, wait, options) {
    let context;
    let args;
    let result;
    let timeout = null;
    let previous = 0;
    if (!options)
        options = {};

    let later = function () {
        previous = options.leading === false ? 0 : _.now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout)
            context = args = null;
    };
    return function () {
        let now = _.now();
        if (!previous && options.leading === false)
            previous = now;
        let remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout)
                context = args = null;
        } else if (!timeout && options.trailing !== false) { // 最后一次需要触发的情况
            timeout = setTimeout(later, remaining);
        }
        return result;
    };
};

_.debounce = function (func, wait, immediate) {
    let timeout; 
    let args; 
    let context; 
    let timestamp;
    let result;
    let later = function () {
        let last = _.now() - timestamp;
        if (last < wait && last >= 0) {
            timeout = setTimeout(later, wait - last);
        } else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, [...args, context]);
                if (!timeout)
                    context = args = null;
            }
        }
    };
    return function () {
        context = this;
        args = arguments;
        timestamp = _.now();
        let callNow = immediate && !timeout;
        if (!timeout)
            timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, [...args, context]);
            context = args = null;
        }
        return result;
    };
};

export { _ };